/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CalendarCount = {
    properties: {
        count: {
    type: 'number',
    isRequired: true,
},
    },
};